import { render, staticRenderFns } from "./GeneralInfoCard.vue?vue&type=template&id=0fad173b&scoped=true"
import script from "./GeneralInfoCard.vue?vue&type=script&lang=js"
export * from "./GeneralInfoCard.vue?vue&type=script&lang=js"
import style0 from "./GeneralInfoCard.vue?vue&type=style&index=0&id=0fad173b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fad173b",
  null
  
)

export default component.exports